export const NumberWithCommas = (x) => {
  let num = x.toString().split('.')
  num[0] = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return num.join('.')
}

export const ShortString = (value) => {
  if (value.length > 15) {
    return `${value.substring(0, 15)}...`
  } else {
    return value
  }
}
